import { Images } from "./Images";
import Lists from "./Lists";
import { Description, Names, ProjectLinks, Review } from "./Strings";

interface IProject {
  name: string;
  icon: string;
  image: string;
  review?: string;
  darkImage: string;
  techstack: string[];
  description: string;
  projectURL?: string;
}

export default class ProjectModel implements IProject {
  name: string;
  icon: string;
  image: string;
  darkImage: string;
  techstack: string[];
  description: string;
  review?: string | undefined;
  projectURL?: string | undefined;

  constructor(
    name: string,
    icon: string,
    image: string,
    techstack: string[],
    darkImage: string,
    description: string,
    review?: string,
    projectURL?: string
  ) {
    this.icon = icon;
    this.name = name;
    this.image = image;
    this.review = review;
    this.darkImage = darkImage;
    this.techstack = techstack;
    this.projectURL = projectURL;
    this.description = description;
  }
}

const cm = new ProjectModel(
  Names.cm,
  Images.icCM,
  Images.cmLight,
  Lists.cm,
  Images.cmDark,
  Description.cm,
  Review.cm,
  ProjectLinks.cm
);
const bf = new ProjectModel(
  Names.bidForest,
  Images.icBF,
  Images.bfLight,
  Lists.bf,
  Images.bfDark,
  Description.bidForest
);
const hp = new ProjectModel(
  Names.hp,
  Images.icHP,
  Images.grove,
  Lists.hp,
  Images.grove,
  Description.hp,
  Review.hp
);
const asp = new ProjectModel(
  Names.asp,
  Images.icASP,
  Images.asp,
  Lists.asp,
  Images.asp,
  Description.asp
);
const nda = new ProjectModel(
  Names.nda,
  Images.icNDA,
  Images.nda,
  Lists.nda,
  Images.nda,
  Description.nda,
  Review.nda,
  ProjectLinks.nda
);
const arm = new ProjectModel(
  Names.ctrlARM,
  Images.icArm,
  Images.armLight,
  Lists.arm,
  Images.armDark,
  Description.ctrlARM
);
const mnm = new ProjectModel(
  Names.mnm,
  Images.icMNM,
  Images.mnmLight,
  Lists.mnm,
  Images.mnmDark,
  Description.mnm,
  Review.mnm,
  ProjectLinks.mnm
);
const miko = new ProjectModel(
  Names.miko,
  Images.icMiko,
  Images.mikoLight,
  Lists.miko,
  Images.mikoDark,
  Description.miko,
  Review.miko,
  ProjectLinks.miko
);
const payclix = new ProjectModel(
  Names.payClix,
  Images.icPayclix,
  Images.payclixLight,
  Lists.payclix,
  Images.payclixDark,
  Description.payClix,
  Review.payclix
);
const souqcards = new ProjectModel(
  Names.souqcards,
  Images.icSouqcards,
  Images.souqcardsLight,
  Lists.souqcards,
  Images.souqcardsDark,
  Description.souqcards,
  Review.souqcards,
  ProjectLinks.souqcards
);

export const projects = [
  miko,
  souqcards,
  arm,
  hp,
  nda,
  asp,
  bf,
  cm,
  payclix,
  mnm,
];
